export default __webpack_public_path__ + "static/media/icon-redirect-6.4b005cb3.svg";